import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { Product } from "@~/types/types.ts";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import classNames from "classnames/bind";
import styles from "./PromoMessages.module.scss";

const cx = classNames.bind(styles);

type Props = {
  product: Product;
  showModal: boolean;
  onClose: () => void;
};

export const PromoModal = ({ product, showModal, onClose }: Props) => {
  const { variant } = useVariant();

  const promoMessages =
    product.messaging
      ?.filter((m) => m.type === "promotional")
      .map((m) => m.title) || [];

  if (promoMessages.length === 0) {
    return null;
  }

  return (
    <Modal
      className={cx("promoModal")}
      footer={false}
      isOpen={showModal}
      onClose={onClose}
      title="Offers"
    >
      {promoMessages.map((promoMessage) => (
        <p key={promoMessage} data-testid="product-card-promo-message">
          {promoMessage}
        </p>
      ))}
      <UnderlinedButton href={variant?.pdpURL.url || ""} tag="a">
        View full product information
      </UnderlinedButton>
    </Modal>
  );
};
